import { PropsWithChildren } from 'react'

export const OnBoardingCard = ({ children }: PropsWithChildren) => {
  return <div className={'tw-shadow-md tw-rounded-lg tw-w-96 tw-bg-primary-500'}>{children}</div>
}
